import { render, staticRenderFns } from "./_huanjing.vue?vue&type=template&id=30502e5f&scoped=true"
import script from "./_huanjing.vue?vue&type=script&lang=js"
export * from "./_huanjing.vue?vue&type=script&lang=js"
import style0 from "./_huanjing.vue?vue&type=style&index=0&id=30502e5f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30502e5f",
  null
  
)

export default component.exports